module.exports = __webpack_public_path__ + "img/mine.29688fe9.svg";